module.exports = __webpack_public_path__ + "img/owla.d6db99dc.svg";